import React from 'react';
import {
    HashRouter as Router,
    Route,
    Switch
} from 'react-router-dom';
import Home from './Home';


const Routes = () => (
    <Router >
        <Switch>
            <Route path="/" render={props => <Home {...props} />} />
        </Switch>
    </Router>
);

export default Routes;